import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../../node_modules/lit-element/node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`:host{display:inline-flex;justify-content:center;width:100%}:host button{min-height:1em;min-width:1em}:host input{color:#008100;font-size:1em;min-height:2em;width:80%}:host .product-search-container{width:80%}`;

export { css_248z as default };
